import { useContext, useState, useEffect } from 'react';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton'; 
import InputDataTableDynamic from './InputDataTableDynamicCopy.jsx';
import InputTableRow from './InputTableRow';
import Autocomplete from './AutoCompleteInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import copyObjectToArray from '../functions/copyObjectToArray';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddRollingBonusModal = () => {
    // get context from parent
    const {
        addRollingBonusModal, 
        setAddRollingBonusModal, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        subCompanyList,
        rollingBonusAddConfig, 
        rollingBonusLists,
        showSpinner
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
    } = useContext(HttpContext);
    // initialize state
    const [companyId, setCompanyId] = useState(''); 
    const [companyError, setCompanyError] = useState(false); 
    const [values, setValues] = useState([]); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);

    // function wrapper to pass row component
    const RowComponent = ( data, setData, count, config, length, setLength,addButtonText ) => { 
        return <InputTableRow data={data} setData={setData} count={count} config={config} length={length} setLength={setLength} lists={rollingBonusLists} error={error} setError={setError} addButtonText={addButtonText}/>
    }

    // event handler for submit button click
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // validate companyid selection 
            if (!subCompanyList.includes(companyId)) {
                snackbarAlert(true, 'Invalid Payout Company ID Selection.', 'error'); 
                setCompanyError(companyError => companyError = true); 
                reject(); 
                return; 
            }
            else {
                setCompanyError(companyError => companyError = false); 
            }
            // run dynamic validation on input array
            let requestValues = copyObjectToArray(values); 
            // slice off blank row 
            requestValues = requestValues.slice(0, requestValues.length-1); 
            // check that there is at least one bonus setup
            if (requestValues.length == 0){
                snackbarAlert(true, 'Error: Please input at least one Bonus Setup.', 'error'); 
                reject(); 
                return;
            }
            // validate input
            let checkError = validateInputArray(
                requestValues, 
                rollingBonusAddConfig,
                dynamicValidation,
                rollingBonusLists, 
                snackbarAlert,  
                error, 
                setError, 
                dynamicTransformation, 
                { }
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }           
            // make POST request 
            let response; 
            POST('/client/rollingBonus', { 
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                companyid: companyId, 
                BonusArgs: requestValues,                 
            }).then(res => {
                console.log(res);
                response = res; 
                // hide modal 
                setAddRollingBonusModal(addRollingBonusModal => addRollingBonusModal = false);
                // default all values on success
                setValues(values => values =  [{ blank: true }]);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res); 
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to run on config change
    useEffect(() => {
        if (rollingBonusAddConfig) {
            // set the config 
            setConfig(config => config = rollingBonusAddConfig); 
            // initialize values object 
            let obj = { blank: true }; 
            // set values state
            setValues(values => values = [obj])
        }
    }, [rollingBonusAddConfig]); 

    return(
        <> 
            <CCOffcanvas
                title='Add Rolling Bonus'
                onCanvasClose={()=>setAddRollingBonusModal(addRollingBonusModal => addRollingBonusModal = false)}
                show={addRollingBonusModal}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
                >
                <div className="d-flex flex-column h-100">
                    <div className="bg-white p-3" style={{ fontSize: "14px" }}>
                        <Autocomplete tag='Payout Company ID' value={companyId} setValue={setCompanyId} list={subCompanyList} width={'32%'} showError={companyError}/>
                    </div>
                    <div className="p-3 trail-section flex-grow-1 overflow-scroll">
                        <div className="bg-white trail-card">
                            <div>
                                <InputDataTableDynamic RowComponent={RowComponent} config={config} dataList={values} setDataList={setValues} showSpinner={showSpinner} addButtonText = 'Add Bonus Tier'/>           
                            </div>
                        </div>
                    </div>
                    {/* button to submit edits to rebate setup */}
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"} 
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                            onButtonClick={()=>setAddRollingBonusModal(addRollingBonusModal => addRollingBonusModal = false)}    
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>   
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AddRollingBonusModal; 